import { ArcGISIdentityManager } from '@esri/arcgis-rest-request';
import { useSiteConfig } from '@innovyze/stylovyze';
import React, { useEffect } from 'react';

import { addRouteNamespace } from '@Utils/actions';

export default function ArcGisOauthCallback(): React.ReactElement {
	const { config } = useSiteConfig();
	const isInitializingIntegration = !!localStorage.getItem(
		'initializingArcGisItegration',
	);

	useEffect(() => {
		if (config && config.esri && isInitializingIntegration) {
			localStorage.removeItem('initializingArcGisItegration');
			const { origin } = window.location;
			ArcGISIdentityManager.completeOAuth2({
				clientId: config.esri.clientId,
				redirectUri: origin + addRouteNamespace('oauth/esri'),
				pkce: true,
				expiration:
					Number(config?.esri?.refreshTokenExpiresIn) ||
					60 * 24 * 365,
			}).catch(e => console.log('ArcGisOauthCallback errored ', e));
		}
	}, [config]);
	return <div>Authenticated</div>;
}
